var SpriteSymbol = require("../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "cancel",
  "use": "cancel-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"cancel\">\n    <path d=\"M12.375 1L8 5.375L3.625 1L1 3.625L5.375 8L1 12.375L3.625 15L8 10.625L12.375 15L15 12.375L10.625 8L15 3.625L12.375 1Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol